<template>
  <div class="w-screen bg-white">
    <!-- Request Demo Modal -->
    <DemoModal
      v-if="showDemoModal"
      :show-demo-modal="showDemoModal"
      @closeShowModal="toggleDemoModal"
      @receivedDemo="showDemoReceivedMessage"
    />
    <!-- features deatail modal -->
    <FeaturesDetailModal
      v-if="showFeaturesModal"
      :show-demo-modal="showFeaturesModal"
      @closeShowModal="toggleFeaturesShowModal"
    />

    <!-- Banner -->
    <div
      class="container flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px] mb-12 sm:mb-16 md:mb-24 lg:mb-[120px]"
    >
      <Banner
        id="home"
        :home-page="true"
        btn-class="flex"
        :title="['The No. 1', 'AI-Powered', 'Platform for Smarter School Management']"
        description="HP_BANNER_DESC_3"
        @request-demo="toggleDemoModal"
      />
    </div>
    <TrustedBy />
    <div
      class="container flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px] my-12 sm:my-16 md:my-24 lg:my-[120px]"
    >
      <DemoSection />
      <ScrollableContentAndCarousel />
    </div>
    <CARTERTO />
    <div
      class="container flex flex-col gap-12 sm:gap-16 md:gap-24 lg:gap-[120px] my-12 sm:my-16 md:my-24 lg:my-[120px]"
    >
      <Coverage />
      <Testimonials />
      <!-- Footer -->
    </div>
    <Footer id="contact" />
  </div>
</template>

<script>
import ScrollableContentAndCarousel from '@src/views/home-page/ScrollableContentAndCarousel.vue'
import Coverage from '@views/home-page/Coverage.vue'
import TrustedBy from '@src/views/home-page/TrustedBy.vue'
import Footer from '@/src/components/misc/Footer.vue'
import Banner from '@/src/components/misc/Banner.vue'
import DemoSection from '@components/home-page/DemoSection.vue'
import FeaturesDetailModal from '@src/components/modals/FeaturesDetailModal.vue'
import CARTERTO from '@src/views/home-page/CaterTo.vue'
import Testimonials from '@/src/views/landingPage/TestimonialsView.vue'
import DemoModal from '@src/components/modals/DemoModal.vue'
import { useMeta } from 'vue-meta'

export default {
  components: {
    ScrollableContentAndCarousel,
    Coverage,
    TrustedBy,
    Footer,
    Banner,
    DemoSection,
    FeaturesDetailModal,
    CARTERTO,
    Testimonials,
    DemoModal,
  },
  setup() {
    useMeta({
      title: 'Home',
      meta: [
        {
          name: 'description',
          content: 'Home',
        },
      ],
    })
  },

  data() {
    return {
      showFeaturesModal: false,
      showDemoModal: false,
      landingPage: 'landingPage',
      isTab: window.outerWidth <= 768,
    }
  },
  methods: {
    toggleDemoModal() {
      this.showDemoModal = !this.showDemoModal
    },
    toggleFeaturesShowModal() {
      this.showFeaturesModal = !this.showFeaturesModal
    },
  },
}
</script>
